// Temporary inter-op

export {MeasuredChatView} from '../../components/lists/MeasuredChatView';



// WEBPACK FOOTER //
// ./src/js/core-components/measured-chat-view/MeasuredChatView.js